function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M166.6,36.2L100,12.5L33.4,36.2c0,0-11,73.8,0,94.9c9.3,18,66.6,56.4,66.6,56.4s57.3-38.4,66.6-56.4 C177.6,110,166.6,36.2,166.6,36.2z M155.2,125.5c-1.1,2.1-6.6,10.3-33.2,30.7c-8.4,6.4-16.5,12.2-22.1,16.1 c-5.5-3.9-13.7-9.7-22.1-16.1c-26.6-20.4-32.1-28.6-33.2-30.7c-1.2-2.4-5.1-12.9-2.8-48.8c0.8-12.5,2.1-24.1,3-31.3l55-19.6l55,19.6 c0.9,7.2,2.2,18.8,3,31.3C160.3,112.5,156.5,123.1,155.2,125.5L155.2,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M106.1,95.1c10.6-2.7,18.5-12.1,18.5-23.3c0-13.3-11-24-24.6-24s-24.6,10.8-24.6,24 c0,11.2,7.9,20.7,18.5,23.3v53.8h12.1v-23.4h24.2V113h-24.2V95.1z M88.2,71.8c0-6.4,5.3-11.5,11.8-11.5c6.5,0,11.8,5.2,11.8,11.5 s-5.3,11.5-11.8,11.5S88.2,78.2,88.2,71.8z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.54f4040a6e61c8fe39cfa7856ecb6d41.svg";
export { ForwardRef as ReactComponent };